import { TriangleAlert } from '@parrot-software/design-system/icons';
import { Button } from '@parrot-software/design-system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { StepCard } from '@identity/presentation/components/base';
import { PROFILE_ROUTE } from '@identity/presentation/constants';

/**
 * What a tab sees when a later send replaced the verification it was waiting for.
 *
 * It is not a success card, because nothing succeeded here, and it offers no retry: asking again
 * would query the same dead verification and get the same answer. The two things that do unblock
 * this tab — opening the newer link, or starting over — fit in one sentence and one button.
 */
export const VerificationSupersededScreen = () => {
  const { t } = useTranslation('identity');
  const history = useHistory();

  return (
    <StepCard
      align="center"
      description={t('profile.superseded.body')}
      icon={
        <span className="flex size-16 items-center justify-center rounded-full bg-bg-warning">
          <TriangleAlert aria-hidden className="size-8 text-warning" />
        </span>
      }
      title={t('profile.superseded.title')}
    >
      <div className="flex flex-col gap-6 font-sans sm:items-center">
        <Button className="w-full sm:w-fit" onClick={() => history.replace(PROFILE_ROUTE)} type="button">
          {t('profile.superseded.action')}
        </Button>
      </div>
    </StepCard>
  );
};
